export default {
  UPDATE_ACCESS_TOKEN: (state, accessToken) => {
    state.accessToken = accessToken;
  },
  LOGIN: (state, accessToken) => {
    state.accessToken = accessToken;
    state.isLoggedIn = true;
  },
  LOGOUT: state => {
    state.accessToken = null;
    state.isLoggedIn = false;
  },
  SET_USER_CONFIGS(state, configs) {
    state.userConfigs = configs;
  },
  SET_USER_SERVICE_PROFILE(state, userServiceProfile) {
    state.userServiceProfile = userServiceProfile;
  },
  UPDATE_MULTILOGIN(state, hasMultilogin) {
    state.hasMultilogin = hasMultilogin;
  },
};
